export const TEST_ID_CANCEL_CONFIRMATION_MAIN =
  'cancel-confirmation-dialog-outer-container';

export const TEST_ID_CANCEL_CONFIRMATION_BUTTON_GROUP =
  'cancel-retrieval-step-button-group';
